<script setup>
// Static post-deletion confirmation screen. No props/interactivity.
</script>

<template>
  <div class="auth-card hf-glass">
    <h1>Your account has been deleted</h1>
    <p style="color:var(--ink-2);font-size:0.9375rem;line-height:1.6;margin-bottom:24px">
      You have 90 days to restore it if you change your mind — email
      <a href="mailto:support@dauberhq.com">support@dauberhq.com</a>. After that, it's gone for good.
    </p>
    <div class="auth-links"><a href="/login">&larr; Back to login</a></div>
  </div>
</template>
